import { clsx } from 'clsx'

import { Member } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'

interface Props {
  member: Member
  highlighted: boolean
  stretchX: string
  titleSizeClass: string
}
export const MemberName = ({
  member,
  highlighted,
  stretchX,
  titleSizeClass,
}: Props) => {
  const { Link } = useRouter()

  return (
    <Link
      href={member?.relativeUrl}
      className={clsx(stretchX, 'min-w-0 break-words')}
      onClick={e => e.stopPropagation()}
    >
      <h2
        className={clsx(
          'text-content line-clamp-3',
          titleSizeClass,
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
        translate="no"
      >
        {member?.name}
      </h2>
    </Link>
  )
}
